<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'register-step-1-content'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Selesaikan Pembayaran" :type="'close'" @back="close" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="formReady">
                <div class="p-t-16">
                    <div class="bg-gray p-y-8 p-x-20 d-flex d-flex-between-center m-d-16">
                        <div class="m-r-16">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.99992 0.333344H11.9999C12.9204 0.333344 13.6666 1.07954 13.6666 2.00001V12C13.6666 12.9205 12.9204 13.6667 11.9999 13.6667H1.99992C1.07944 13.6667 0.333252 12.9205 0.333252 12V2.00001C0.333252 1.07954 1.07944 0.333344 1.99992 0.333344ZM6.99991 2.83329C6.53967 2.83329 6.16657 3.20639 6.16657 3.66662C6.16657 4.12686 6.53967 4.49996 6.99991 4.49996H7.00657C7.46681 4.49996 7.83991 4.12686 7.83991 3.66662C7.83991 3.20639 7.46681 2.83329 7.00657 2.83329H6.99991ZM6.16658 6.16665C5.70635 6.16665 5.33325 6.53974 5.33325 6.99998C5.33325 7.46022 5.70635 7.83332 6.16658 7.83332V10.3333C6.16658 10.7936 6.53968 11.1666 6.99992 11.1666H7.83325C8.29349 11.1666 8.66658 10.7936 8.66658 10.3333C8.66658 9.87308 8.29349 9.49998 7.83325 9.49998L7.83325 6.99998C7.83325 6.53974 7.46016 6.16665 6.99992 6.16665H6.16658Z"
                                    fill="#6F7287"
                                />
                            </svg>
                        </div>
                        <p class="m-d-0 f-12 f-regular f-c-midgrey">
                            Perangkat WA Autosender telah dibuat. Selesaikan pembayaran untuk mulai menggunakannya.
                        </p>
                    </div>
                    <div class="p-x-20 f-14 f-regular m-d-16">
                        <div class="m-d-12">
                            <p class="m-d-0 f-c-midgrey">Batas akhir pembayaran</p>
                            <div class="d-flex-between-center">
                                <span>{{ $moment(tagihan.expired_at).format("dddd, Do MMMM YYYY HH:mm") }}</span>
                                <span class="f-c-midgrey" id="countdown-time">EXPIRED</span>
                            </div>
                        </div>
                        <div class="separator-line m-d-12"></div>
                        <div>
                            <p class="m-d-0 f-c-midgrey">Total tagihan</p>
                            <div class="d-flex-between-center">
                                <div class="d-flex" style="align-items: center;">
                                    <p class="m-d-0 m-r-6">{{ tagihan.total | currency }}</p>
                                    <BtnSalin
                                        :copy-text="tagihan.total.toString()"
                                        id="salin-tagihan"
                                        :btn-label="'Salin'"
                                    />
                                </div>
                                <div>
                                    <p class="m-d-0 f-c-blue" @click="gotoDetail">Detail tagihan</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="separator m-d-16"></div>
                    <div class="p-x-20 m-d-16 f-14 f-regular">
                        <p class="m-d-12 f-c-midgrey">
                            Lakukan pembayaran ke salah satu rekening berikut:
                        </p>
                        <ListBankPembayaran :list-bank="listBank" />
                    </div>
                    <div class="separator m-d-16"></div>
                    <div class="p-x-20 f-12 f-c-midgrey f-regular m-d-16">
                        Tagihan telah dikirim ke nomor whatsapp Anda di +{{ getToken.Telp }}, harap segera
                        selesaikan pembayaran. Sistem Smartlink akan segera melakukan verifikasi secara otomatis.
                    </div>
                    <div class="p-x-20 f-14 f-regular m-d-20">
                        <p class="m-d-0 f-c-midgrey">
                            Nomor tagihan: <span class="f-c-black">{{ tagihan.nomor_bill }}</span>
                        </p>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import BtnSalin from "../components/BtnSalin.vue";
import ListBankPembayaran from "../components/ListBankPembayaran.vue";

import { moduleName } from "../store/state";

export default {
    name: "Pembayaran",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        BtnSalin,
        ListBankPembayaran,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_autosender.daftar_perangkat" || from.name === "wa_autosender.detail_perangkat") {
                vm.setBackLInk(from.name);
                vm.init();
            } else if (from.name === "wa_autosender.detail_perangkat.ubah_paket_confirm") {
                vm.setBackLInk("wa_autosender.detail_perangkat");
            } else {
                vm.setFormReady(true);
            }
        });
    },
    data() {
        return { formReady: false, backLink: "wa_autosender.daftar_perangkat" };
    },
    mounted() {
        this.init();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
        formReady: function(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.startCount();
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            tagihan: "tagihan",
            listBank: "listBank",
            response: "response",
            jwtToken: "jwtToken",
        }),
        getToken() {
            return this.jwtToken();
        },
    },
    methods: {
        ...mapActions({
            getListBank: `${moduleName}/getListBank`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
        }),
        async init() {
            let { id_device, id_bill } = this.$route.params;
            await this.getListBank({ iddevice: id_device, idbill: id_bill, loadDetailTagihan: true });
        },
        close() {
            if (this.backLink === "wa_autosender.daftar_perangkat") {
                this.resetListPerangkat();
            }
            this.$router.push({ name: this.backLink });
        },
        startCount() {
            let that = this;

            let countDownDate = that.$moment(that.tagihan.expired_at);
            var counDown = setInterval(() => {
                let now = that.$moment();
                let diff = countDownDate - now;
                let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((diff % (1000 * 60)) / 1000);

                let el = document.getElementById("countdown-time");

                if (el) {
                    el.innerHTML = `${hours} : ${minutes} : ${seconds}`;
                }

                if (diff < 0 || !el) {
                    clearInterval(counDown);
                    el.innerHTML = "EXPIRED";
                }
            }, 1000);
        },
        gotoDetail() {
            this.$router.push({ name: "wa_autosender.pembayaran.detail_pembayaran" });
        },
        setBackLInk(val) {
            this.backLink = val;
        },
        setFormReady(val) {
            this.formReady = val;
        },
    },
};
</script>
